export default __webpack_public_path__ + "static/media/Zap.758f4bb7.png";